<template>
  <div
    :class="b('', { variant })"
    :style="getStyle"
  >
    {{ getText }}
  </div>
</template>

<script lang="ts">
  import { PropType, defineComponent } from 'vue';
  import { TextLabel } from '@/types/product';

  // type Setup = {};
  // type Data = {};

  type StyleProperties = {
    backgroundColor: string;
  };

  /**
   * Displays an overlay with text on top of some content.
   */
  export default defineComponent({
    name: 'c-text-overlay',

    // components: {},

    props: {
      /**
       * Define the overlay text.
       */
      text: {
        type: String,
        default: '',
      },

      /**
       * Define the overlay label.
       */
      label: {
        type: Object as PropType<TextLabel>,
        default: null,
      },

      /**
       * Define the display variant.
       */
      variant: {
        type: String,
        default: 'fullwidth',
        validate: (value: string) => ['fullwidth', 'label'].includes(value),
      },
    },
    // emits: [],

    // setup(): Setup {
    //   return {};
    // },
    // data(): Data {
    //   return {};
    // },

    computed: {
      getText(): string {
        return this.label?.label || this.text;
      },

      getStyle(): StyleProperties {
        const style = {} as StyleProperties;

        if (this.variant === 'label' && this.label?.backgroundColor) {
          style.backgroundColor = this.label?.backgroundColor;
        }

        return style;
      },
    },
    // watch: {},

    // beforeCreate() {},
    // created() {},
    // beforeMount() {},
    // mounted() {},
    // beforeUpdate() {},
    // updated() {},
    // activated() {},
    // deactivated() {},
    // beforeUnmount() {},
    // unmounted() {},

    // methods: {},
    // render() {},
  });
</script>

<style lang="scss">
  @use '@/setup/scss/mixins';
  @use '@/setup/scss/variables';

  .c-text-overlay {
    @include mixins.z-index(front);
    @include mixins.hyphens;

    position: absolute;
    left: 0;
    top: 0;
    display: flex;
    align-items: center;
    justify-content: center;

    &--variant-fullwidth {
      width: 100%;
      height: 100%;
      background-color: rgba(var(--theme-color-grayscale--1000-rgb), 0.5);
      color: var(--theme-color-primary--1);
      z-index: 1;
    }

    &--variant-label {
      width: fit-content;
      padding: 0.3rem 0.6rem;
      background-color: rgba(var(--theme-color-grayscale--0-rgb), 0.5);
      color: var(--theme-color-primary--3);
      z-index: 2;
    }
  }
</style>
